<template functional>
	<div>
		<div v-if="parent.hasValidationErrors" class="alerts">
			<ul>
				<li v-for="error in parent.errors" :key="`${ field }-${ error }`"><span class="fa fa-flag"></span>{{ error }}</li>
			</ul>
		</div>
		<div class="input-container" :class="{ errors: parent.hasValidationErrors }">
			<slot name="title"></slot>
			<span v-if="!$slots.title" class="input-title">{{ parent.getFieldName(parent.field) }}</span>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {};
</script>
